<template>
  <section class="hero-banner">
    <div class="hero-container">
      <!-- 左侧内容区 -->
      <div class="left-content">
        <!-- 标签 -->
        <div class="protocol-tag">[ BLOCKCHAIN FORENSICS PROTOCOL ]</div>

        <!-- 标题 -->
        <h1 class="main-title">
          Recover Your<br>
          <span class="gradient-text">Stolen Crypto</span>
        </h1>

        <!-- 描述 -->
        <p class="description">
          Advanced blockchain forensics & legal recovery strategies. Track stolen assets across all major networks. Our
          team has recovered <strong>$1.83M+</strong> with <strong>94.7%</strong> success rate.
        </p>

        <!-- 按钮组 -->
        <div class="buttons">
          <button class="btn-start">
            ⚡ START RECOVERY <span class="arrow">→</span>
          </button>
          <button class="btn-about">
            → ABOUT US
          </button>
        </div>

        <!-- 统计区（移动端字体调小） -->
        <div class="stats">
          <div class="stat-item">
            <div class="num">5,000+</div>
            <div class="label">CASES REVIEWED</div>
          </div>
          <div class="stat-item">
            <div class="num">94.7%</div>
            <div class="label">SUCCESS RATE</div>
          </div>
          <div class="stat-item">
            <div class="num">24/7</div>
            <div class="label">MONITORING</div>
          </div>
        </div>
      </div>

      <!-- 右侧视觉区（移动端移至下方展示） -->
      <div class="right-visual">
        <!-- 底部大绿色框与锁 -->
        <div class="green-frame">
          <div class="lock-icon">🔒</div>
        </div>

        <!-- 左侧终端窗口 -->
        <div class="terminal terminal-scan">
          <div class="term-header">
            <span class="dot red"></span>
            <span class="dot yellow"></span>
            <span class="dot green"></span>
            <span class="title">RECOVERY_SCAN.exe</span>
          </div>
          <div class="term-body">
            <p><span class="green">$ blockchain_trace init</span></p>
            <p><span class="green">&gt; initializing forensic protocol</span></p>
            <p><span class="green">&gt; Connecting to mainnet nodes...</span></p>
            <p><span class="orange">[!] 5000+ cases processed</span></p>
            <p><span class="green">$ scan_wallets --deep</span></p>
            <p><span class="green">&gt; Scanning transaction history...</span></p>
            <div class="cursor"></div>
          </div>
        </div>

        <!-- 右侧网络状态终端 -->
        <div class="terminal terminal-network">
          <div class="term-header">
            <span class="dot red"></span>
            <span class="dot yellow"></span>
            <span class="dot green"></span>
            <span class="title">NETWORK_STATUS</span>
          </div>
          <div class="term-body">
            <p>Bitcoin: <span class="green">● ACTIVE</span></p>
            <p>Ethereum: <span class="green">● ACTIVE</span></p>
            <p>BNB Chain: <span class="green">● ACTIVE</span></p>
            <p>Tron: <span class="green">● ACTIVE</span></p>
            <p>Solana: <span class="green">● ACTIVE</span></p>
            <div class="success-rate">
              <span class="orange">[+] Recovery Success Rate</span>
              <div class="progress-bar">
                <div class="progress" style="width: 94.7%;"></div>
                <span class="percent orange">94.7% [####]</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroBanner'
}
</script>

<style scoped>
/* 全局背景与网格线 */
.hero-banner {
  background-color: #070b14;
  background-image: linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  padding: 100px 10%;
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-container {
  max-width: 1400px;
  width: 100%;
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 50px;
  align-items: center;
}

/* 左侧样式 */
.left-content {
  max-width: 600px;
}

.protocol-tag {
  display: inline-block;
  border: 1px solid #1a6e4b;
  color: #00ff88;
  padding: 8px 15px;
  font-size: 0.9rem;
  font-family: 'Courier New', monospace;
  letter-spacing: 1px;
  margin-bottom: 30px;
  border-radius: 4px;
}

.main-title {
  font-size: 4.5rem;
  line-height: 1.1;
  font-weight: 800;
  margin: 0 0 30px;
  color: #ffffff;
}

/* 渐变文字效果 */
.gradient-text {
  background: linear-gradient(90deg, #00ff88, #4fd1c5);
  -webkit-background-clip: text;
  color: transparent;
  display: inline-block;
  text-shadow: 0 0 30px rgba(0, 255, 136, 0.3);
}

.description {
  font-size: 1.2rem;
  line-height: 1.8;
  color: #a0b3cc;
  margin-bottom: 40px;
}

.description strong {
  color: #fff;
  font-weight: bold;
}

.buttons {
  display: flex;
  gap: 20px;
  margin-bottom: 60px;
}

.btn-start {
  background: linear-gradient(90deg, #a5f3c1, #00ff88);
  color: #000;
  border: none;
  padding: 18px 30px;
  font-size: 1.1rem;
  font-weight: 700;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s ease;
}

.btn-start .arrow {
  font-size: 1.3rem;
}

.btn-start:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(0, 255, 136, 0.3);
}

.btn-about {
  background: transparent;
  color: #fff;
  border: 1px solid #2a303c;
  padding: 18px 30px;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-about:hover {
  border-color: #00ff88;
  color: #00ff88;
}

.stats {
  display: flex;
  gap: 60px;
}

.stat-item .num {
  font-size: 3rem;
  font-weight: 800;
  color: #00ff88;
  margin-bottom: 5px;
}

.stat-item .label {
  font-size: 0.9rem;
  font-family: monospace;
  color: #a0b3cc;
  letter-spacing: 1px;
}

/* 右侧视觉区 */
.right-visual {
  position: relative;
  height: 500px;
}

.green-frame {
  width: 180px;
  height: 280px;
  border: 2px solid #00ff88;
  border-radius: 20px;
  background: linear-gradient(180deg, #0d1117, #000);
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 30px rgba(0, 255, 136, 0.2);
}

.lock-icon {
  font-size: 4rem;
}

.terminal {
  background: #0d1117;
  border: 1px solid #2a303c;
  border-radius: 8px;
  font-family: monospace;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  position: absolute;
  z-index: 2;
}

.term-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 15px;
  border-bottom: 1px solid #2a303c;
  color: #a0b3cc;
  font-size: 0.9rem;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.dot.red {
  background: #ff5f56;
}

.dot.yellow {
  background: #ffbd2e;
}

.dot.green {
  background: #27c93f;
}

.title {
  margin-left: 10px;
  color: #00ff88;
}

.term-body {
  padding: 15px;
  font-size: 1rem;
  line-height: 1.6;
}

.term-body p {
  margin: 0 0 8px;
}

.green {
  color: #00ff88;
}

.orange {
  color: #ffbd2e;
}

.terminal-scan {
  width: 350px;
  top: 120px;
  left: 0;
  z-index: 3;
}

.terminal-network {
  width: 280px;
  top: 250px;
  left: 150px;
  z-index: 4;
}

.success-rate {
  margin-top: 15px;
}

.progress-bar {
  background: #1f2937;
  border-radius: 3px;
  height: 15px;
  margin-top: 10px;
  position: relative;
}

.progress {
  background: #00ff88;
  height: 100%;
  border-radius: 3px;
}

.percent {
  position: absolute;
  right: 5px;
  top: -2px;
  font-size: 0.9rem;
}

.cursor {
  width: 8px;
  height: 16px;
  background: #00ff88;
  display: inline-block;
  animation: blink 1s infinite;
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}

/* 响应式适配：中屏及以下（包含平板和手机） */
@media (max-width: 900px) {
  .hero-banner {
    padding: 60px 5%;
  }

  /* 布局改为上下排列，文字在上，图形在下 */
  .hero-container {
    grid-template-columns: 1fr;
    text-align: center;
    gap: 40px;
  }

  .left-content {
    max-width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  /* 整体缩放右侧视觉区，使其适应屏幕且展示在下方 */
  .right-visual {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 400px;
    /* 缩小高度 */
    margin-top: 40px;
    transform: scale(0.75);
    /* 缩放整个图形 */
    transform-origin: top center;
  }

  .buttons {
    flex-direction: column;
    align-items: center;
  }
}

/* 纯手机端适配 */
@media (max-width: 768px) {
  .main-title {
    font-size: 2.8rem;
  }

  /* 字体小一点 */
  .description {
    font-size: 1rem;
  }

  .protocol-tag {
    font-size: 0.8rem;
  }

  .btn-start,
  .btn-about {
    width: 100%;
    justify-content: center;
  }

  /* 统计区：字体明显缩小，允许换行 */
  .stats {
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
  }

  .stat-item .num {
    font-size: 1.8rem;
    /* 统计区数字调小 */
  }

  .stat-item .label {
    font-size: 0.75rem;
    /* 统计区标签调小 */
  }

  /* 稍微缩小整体的高度适应 */
  .right-visual {
    height: 350px;
    transform: scale(0.65);
  }
}
</style>